import { SVGProps } from "react";
import { Interpolation, Theme, css } from "@emotion/react";

export const MoveIcon = (
  props: SVGProps<SVGSVGElement> & {
    css?: Interpolation<Theme>;
  },
) => {
  return (
    <svg
      width="15"
      height="24"
      viewBox="0 0 15 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2 2L12 12L2 22" stroke="currentColor" strokeWidth="3" />
    </svg>
  );
};
